module.exports = __webpack_public_path__ + "static/media/insert-logo.fc28cf91.jpg";